export default "__VITE_ASSET__CtE7v1pm__"